export const countries = {
  Russia: { totalArea: 17.12, color: "#EE000F" },
  Canada: { totalArea: 9.98, color: "#BB060B" },
  China: { totalArea: 9.59, color: "#BDB76B" },
  "United States": { totalArea: 9.52, color: "#FFA07A" },
  Brazil: { totalArea: 8.51, color: "#3CB371" },
  Australia: { totalArea: 7.69, color: "#D8BFD8" },
  India: { totalArea: 3.29, color: "#DB7093" },
  Argentina: { totalArea: 2.78, color: "#FFD700" },
  Kazakhstan: { totalArea: 2.72, color: "#CD5C5C" },
  Algeria: { totalArea: 2.38, color: "#B0C4DE" },
  Albania :{totalArea:1.14 , color:"#fffff"},
  Sudan :{totalArea:2.23 , color:"#B0D800"},
  Kenya :{totalArea:1.22 , color:"#F0FF"},
};
